<template>
    <div id="partners-carousel">

        <div class="overlay">

            <b-container class="text-center text-white py-5">

              <div class="d-flex justify-content-start align-items-center" style="width: 100%;">
                <img src="@/assets/page/partners/iconApostrofe.png" alt="Aspas" class="quote-icon mb-3" />
                <img src="@/assets/page/partners/iconApostrofe.png" alt="Aspas" class="quote-icon mb-3" />
              </div>
              
              <!-- Bloco que troca tudo junto (texto + imagem + nome + cidade) -->
              <transition name="fade" mode="out-in">
                  <div class="depoiment-wrapper" :key="currentIndex">
                      <h3 class="px-2" style="color: var(--white); text-align: center;">
                        {{ depoiments[currentIndex].content }}
                      </h3>

                      <div class="avatar-item active mt-4 d-flex flex-column align-items-center">

                          <div class="avatar-details mt-2">
                              <p>{{ depoiments[currentIndex].title }}</p>
                          </div>

                      </div>
                  </div>
              </transition>

            </b-container>

        </div>

    </div>
</template>


<script>
import dataDepoiments from '@/data/depoiments';

export default {

    data() {
        return {
          depoiments: dataDepoiments,
          currentIndex: 0,
          intervalId: null,
        };
    },

    computed: {
        visibleAvatars() {
          const total = this.depoiments.length;
          const indices = [-2, -1, 0, 1, 2].map(i =>
              (this.currentIndex + i + total) % total
          );
          return indices.map(i => this.depoiments[i]);
        }
    },

    mounted() {
        this.startAutoScroll();
    },

    beforeDestroy() {
        clearInterval(this.intervalId);
    },

    methods: {

        startAutoScroll() {
          this.intervalId = setInterval(() => {
              this.nextDepoiment();
          }, 5000);
        },

        nextDepoiment() {
          this.currentIndex = (this.currentIndex + 1) % this.depoiments.length;
        },

    }
};
</script>

<style scoped lang="scss">

  #partners-carousel {
      background-image:  
          linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0)),
          url("@/assets/page/partners/partinersBackground.png");
      background-repeat: no-repeat;
      background-size: cover;
      width: 100vw;
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
        

      .avatar-item {
          opacity: 0.4;
          transition: all 0.3s ease;
          text-align: center;

          .avatar-img {
            max-width: 80px;
            height: 80px;
            width: 100%;
            border-radius: 50%;
            object-fit: cover;
            border: 1px solid var(--primaryColor) !important;
            margin-bottom: 10px;
            background-color: var(--gray);
          }

          &.active {
            opacity: 1;

            .avatar-details {
                color: var(--white);
                font-size: 2rem;
                line-height: 1.2;
                min-height: 50px;

                p {
                  font-size: 1.5rem;
                  font-style: italic;
                }
            }
          }
      }

      .depoiment {
          min-height: 70px;
          padding: 20px;
          transition: opacity 0.5s ease-in-out;
      }

      .fade-enter-active,
      .fade-leave-active {
          transition: opacity 0.5s ease;
      }

      .fade-enter,
      .fade-leave-to {
          opacity: 0;
      }
  }

  @media screen and (max-width: 991px){
    .depoiment-wrapper {
      h3 {
        font-size: 22px !important;
        padding: none !important;
      }
    }
  }

</style>